// Yhteiset vipupisteet (pivot_points.v3): the `pivotsV3` namespace, in its own
// file so the module's strings grow here, not in fi.js / en.js / sv.js.
// Kinds, roles, answers, lenses and levels match the backend's
// apps/backend/src/modules/pivot_points_v3/view.js and lift.js.

export const pivotsV3Fi = {
  title: 'Yhteiset vipupisteet',
  loading: 'Ladataan…',
  loadError: 'Teemojen lataus epäonnistui: {{message}}',
  saveError: 'Tallennus epäonnistui: {{message}}',
  noInstance: 'Työpajaa ei ole valittu: avaa sivu työpajan linkistä (?instance=…).',
  empty: 'Ei vielä ajoa. Hae yhteiset teemat, kun tiimien ketjut ovat kartalla.',
  view: { cards: 'Kortit', map: 'Kartta', wall: 'Äänet' },
  vote: {
    important: 'Tärkeä',
    hint: 'Tärkeä TKI-tavoitteidenne kannalta — yksi napautus tiimiltä',
    count: '{{count}} tiimiä',
    none: 'Ei vielä ääniä',
    pickTown: 'Valitse kaupunkisi äänestääksesi',
    wallTitle: 'Vipupisteet äänten mukaan',
    wallHint: 'Jokainen tiimi merkitsee korteista ne, jotka ovat tärkeitä sen TKI-tavoitteiden kannalta.',
  },
  demo: {
    title: 'Yhteiset vipupisteet — TKI-yhteistyön kokeilut',
    lead: '{{teams}} kokeiluhankkeen omasta raportoinnista nostetut yhteiset teemat: mikä toistuu useissa kaupungeissa, kenellä on ongelma ja kenellä jo vastaus ({{themes}} teemaa). Vaihda linssiä nähdäksesi teemat tarkastelun teemojen kautta.',
    pick: 'Valitse teema kompassista nähdäksesi sen kortin.',
    source: 'Tilannekuva {{date}}: TKI-työpajan kartta paikallisesti, anonymisoitu aineisto. Vain luku.',
  },
  run: {
    button: 'Hae yhteiset teemat',
    running: 'Haetaan… (noin minuutti)',
    failed: 'Haku epäonnistui: {{message}}',
    latest: 'Ajo {{when}} · {{count}} teemaa',
    none: 'Ei vielä ajoa',
    signIn: 'Haku ja päätökset vaativat fasilitaattorin kirjautumisen.',
  },
  lens: {
    label: 'Linssi',
    none: 'Alhaalta ylös (ei linssiä)',
    'teema-1': 'Teema 1: yritysten pääsy TKI-järjestelmään',
    'teema-2': 'Teema 2: tiedon, datan ja kumppanuuksien yhteensovittaminen',
    'teema-3': 'Teema 3: tutkimuksesta liiketoimintaan',
    'teema-4': 'Teema 4: uusien TKI-ekosysteemien rakentaminen',
    'teemat-yhdessa': 'Teemat yhdessä',
    'uusi-ymmarrys': 'Uusi ymmärrys TKI-yhteistyöstä',
  },
  level: {
    kaytannot: 'käytännöt',
    rakenteet: 'rakenteet ja resurssit',
    dynamiikka: 'dynamiikka ja valta',
    ajattelumallit: 'ajattelumallit',
  },
  kind: { problem: 'ongelma', outcome: 'tulos', mechanism: 'toimintatapa' },
  role: { problem: 'ongelma', answer: 'vastaus', both: 'molemmat', context: 'taustaa' },
  status: { proposed: 'ehdotus', accepted: 'hyväksytty', dismissed: 'piilotettu' },
  facilitator: 'Fasilitaattori',
  loop: { reinforcing: 'Vahvistava kierre', balancing: 'Tasapainottava kierre', delay: 'viiveellä', cards: '{{count}} korttia' },
  factInfo: {
    spread: 'Kaupungit', reach: 'Teemat alavirtaan ja ylävirtaan', loops: 'Kierteet jäsenkorttien läpi', blockers: 'Esteet jäsenkorteissa', none: 'Ei mitään näytettävää.',
    spreadLead: 'Kaupungit, joiden kortteja tässä vipupisteessä on. Rooli kertoo, kuvaavatko kaupungin kortit ongelmaa, vastausta vai molempia.',
    reachLead: 'Alavirtaan johtavat teemat ovat niitä, joihin tämä vipupiste vaikuttaa: jäsenkorteista lähtee syy–seuraus-linkkejä niiden kortteihin. Ylävirtaan ovat teemat, joista vaikutus tulee tähän. Paino on linkkien määrä.',
    loopsLead: 'Kartan kierteet, jotka kulkevat tämän vipupisteen jäsenkorttien kautta: vahvistava kierre voimistaa itseään, tasapainottava hillitsee.',
    blockersLead: 'Jäsenkortit, jotka ovat esteitä.',
    down: 'Alavirtaan', up: 'Ylävirtaan', weight: 'paino {{count}}',
  },
  drawer: { tab: 'Vipupiste', pick: 'Valitse vipupiste kartalta, niin sen kortti avautuu tähän.' },
  generalisation: 'Yhteenveto',
  nextStep: 'Näin jatketaan',
  score: 'Pisteet {{score}}',
  facts: {
    spread: '{{count}} kaupunkia',
    reach: '{{count}} teemaa alavirtaan',
    loops: '{{count}} kierrettä',
    blockers: '{{count}} estettä',
  },
  pairing: 'Pari: ongelma ja vastaus eri kaupungeissa',
  members: { show: 'Näytä jäsenet ({{count}})', hide: 'Piilota jäsenet', source: 'Lähde: {{source}}' },
  info: {
    tab: 'Tietoa',
    title: 'Miten Yhteiset vipupisteet toimii',
    lead: 'Tällä sivulla näkyvät vipupisteet, jotka tekoäly on nostanut kaikkien hankkeiden vaikutuskartoista yhdessä: kohdat, joihin vaikuttamalla TKI-panostusten vipuvaikutus vahvistuu useammassa kaupungissa kerralla.',
    what: { title: 'Mikä vipupiste on', body: 'Vipupiste on rakenne, toimintatapa tai edellytys, ei yksittäinen ratkaisu tai hanke. Jokaisen takana on kortteja vähintään kahden eri hankkeen kartalta: ne ovat vipupisteen jäsenet, ja ne voi avata kortin alareunasta.' },
    where: { title: 'Mistä se tulee', body: 'Tekoäly lukee hankkeiden vaikutuskarttojen aktiiviset kortit, esteet ja kehät ja nostaa niistä yhteiset teemat. Se ei keksi uutta: otsikko on yleistys jäsenten sanomasta, ja huomautus kertoo, missä hankkeet ovat samaa mieltä ja missä ne eroavat. Jokainen ajo on uusi lista; vanhat ajot säilyvät.' },
    lens: { title: 'Linssi', body: 'Linssi on tarkastelutapa koko aineistoon. Tällä sivulla katsotaan teemoja yhdessä: vain vipupisteet, jotka yhdistävät vähintään kahta TKI-teemaa. Jokaisella vipupisteellä on taso: käytännöt, rakenteet ja resurssit, dynamiikka ja valta tai ajattelumallit.' },
    card: { title: 'Mitä kortissa lukee', body: 'Laji kertoo, onko kyse yhteisestä ongelmasta, tuloksesta vai toimineesta toimintatavasta. Kolme kappaletta kuvaavat vipupisteen yleisesti, kertovat havainnot ja yhtäläisyydet hankkeiden välillä ja ehdottavat, miten tästä edetään edellytykseksi. Pisteet ja luvut kertovat, kuinka monta kaupunkia, korttia, kehää ja estettä vipupisteen takana on.' },
    towns: { title: 'Kaupunkien merkit', body: 'Kaupunkimerkki kertoo kaupungin roolin: sillä on ongelma, vastaus tai molemmat. Merkkiä napauttamalla avautuu, mitä juuri tämän kaupungin kortit sanovat tästä vipupisteestä ja mitä sen tiimi on vastannut. Pari syntyy, kun yhdellä kaupungilla on ongelma ja toisella vastaus siihen.' },
    answers: { title: 'Tiimien vastaukset', body: 'Jokainen tiimi vastaa omalla sivullaan, onko vipupiste meidän, osittain meidän vai ei meidän, ja perustelee lyhyesti. Vastaukset näkyvät kortissa kaupungeittain ja kertovat huoneelle, mikä on yhteistä oikeasti.' },
    decide: { title: 'Fasilitaattorin päätös', body: 'Fasilitaattori hyväksyy, hylkää tai nimeää vipupisteen uudelleen. Hyväksytyt vipupisteet siirtyvät seuraavaan vaiheeseen; hylätyt jäävät listaan merkittyinä. Uusi ajo korvaa saman linssin hyväksynnät, joten päätökset tehdään viimeisimmästä listasta.' },
    next: { title: 'Mitä seuraavaksi', body: 'Hyväksytyistä vipupisteistä työstetään edellytykset: mitä pitäisi olla totta, jotta vipu toimii, ja mitä reittejä sinne on. Jäsenkortit ja kaupunkien merkit kertovat, mistä hankkeiden omista kokemuksista reitit löytyvät.' },
  },
  town: { counts: '{{problem}} ongelmakorttia · {{answer}} vastauskorttia tässä vipupisteessä', noMembers: 'Tämän kaupungin kortteja ei ole tässä vipupisteessä.' },
  edges: { into: 'Tulee teemoista', out: 'Vaikuttaa teemoihin' },
  answers: {
    title: 'Tiimien vastaukset',
    none: 'Ei vielä vastauksia.',
    room: '{{yes}} tiimiä sanoo meidän · {{partly}} osittain',
  },
  answer: { yes: 'meidän', no: 'ei meidän', partly: 'osittain' },
  actions: { accept: 'Hyväksy', dismiss: 'Hylkää', restore: 'Palauta', hide: 'Piilota', show: 'Näytä', rename: 'Nimeä uudelleen', save: 'Tallenna', cancel: 'Peruuta' },
  compass: {
    aria: 'Kenellä on vastaus: teemat keskellä, kaupungit kehällä',
    legendTitle: 'Kenellä on vastaus',
    centre: 'yhteiset teemat',
    ring: { many: 'monessa kaupungissa', two: 'kahdessa' },
    zoomIn: 'Lähennä', zoomOut: 'Loitonna', zoomReset: 'Palauta',
  },
  team: {
    subtitle: 'Onko tämä meidän? Yksi napautus teemaa kohti; halutessanne yksi rivi miksi.',
    pick: 'Mikä tiimi olette?',
    pickHint: 'Valinta koskee vain tätä laitetta; vastaukset tallentuvat tiimin nimiin.',
    change: 'Vaihda tiimiä',
    none: 'Yksikään teema ei vielä kosketa tiimiänne.',
    noTeams: 'Työpajassa ei ole tiimejä.',
    reasonPlaceholder: 'Miksi? (valinnainen)',
    saved: 'Tallennettu',
    clear: 'Poista vastaus',
    yourRole: 'Teillä: {{role}}',
  },
};

export const pivotsV3En = {
  title: 'Shared leverage points',
  loading: 'Loading…',
  loadError: 'Loading the themes failed: {{message}}',
  saveError: 'Saving failed: {{message}}',
  noInstance: 'No workshop selected: open the page from the workshop link (?instance=…).',
  empty: 'No run yet. Find the common themes once the teams\' chains are on the map.',
  view: { cards: 'Cards', map: 'Map', wall: 'Votes' },
  vote: {
    important: 'Important',
    hint: 'Important for your R&D goals — one tap per team',
    count: '{{count}} teams',
    none: 'No votes yet',
    pickTown: 'Pick your town to vote',
    wallTitle: 'Leverage points by votes',
    wallHint: 'Each team marks on the cards the ones that matter for its R&D goals.',
  },
  demo: {
    title: 'Shared leverage points — R&D collaboration experiments',
    lead: 'Common themes lifted from the own reporting of {{teams}} experiment projects: what recurs in several towns, who has the problem and who already has an answer ({{themes}} themes). Switch the lens to see the themes through the review themes.',
    pick: 'Pick a theme in the compass to see its card.',
    source: 'Snapshot {{date}}: the R&D workshop map, local, anonymised material. Read-only.',
  },
  run: {
    button: 'Find common themes',
    running: 'Searching… (about a minute)',
    failed: 'The search failed: {{message}}',
    latest: 'Run {{when}} · {{count}} themes',
    none: 'No run yet',
    signIn: 'Running and deciding need a facilitator sign-in.',
  },
  lens: {
    label: 'Lens',
    none: 'Bottom-up (no lens)',
    'teema-1': 'Theme 1: companies\' access to the R&D system',
    'teema-2': 'Theme 2: aligning knowledge, data and partnerships',
    'teema-3': 'Theme 3: from research to business',
    'teema-4': 'Theme 4: building new R&D ecosystems',
    'teemat-yhdessa': 'Themes together',
    'uusi-ymmarrys': 'New understanding of R&D collaboration',
  },
  level: {
    kaytannot: 'practices',
    rakenteet: 'structures and resources',
    dynamiikka: 'dynamics and power',
    ajattelumallit: 'mental models',
  },
  kind: { problem: 'problem', outcome: 'outcome', mechanism: 'mechanism' },
  role: { problem: 'problem', answer: 'answer', both: 'both', context: 'context' },
  status: { proposed: 'proposed', accepted: 'accepted', dismissed: 'hidden' },
  facilitator: 'Facilitator',
  loop: { reinforcing: 'Reinforcing loop', balancing: 'Balancing loop', delay: 'with a delay', cards: '{{count}} cards' },
  factInfo: {
    spread: 'Towns', reach: 'Themes downstream and upstream', loops: 'Loops through the member cards', blockers: 'Blockers among the members', none: 'Nothing to show.',
    spreadLead: 'The towns whose cards are members of this lever. The role says whether the town\'s cards describe the problem, an answer, or both.',
    reachLead: 'Downstream themes are the ones this lever affects: cause-and-effect links run from its member cards to theirs. Upstream themes are where the effect comes from. The weight is the number of links.',
    loopsLead: 'The map\'s loops that pass through this lever\'s member cards: a reinforcing loop amplifies itself, a balancing one dampens.',
    blockersLead: 'Member cards that are blockers.',
    down: 'Downstream', up: 'Upstream', weight: 'weight {{count}}',
  },
  drawer: { tab: 'Lever', pick: 'Pick a lever on the map and its card opens here.' },
  generalisation: 'Summary',
  nextStep: 'How to continue',
  score: 'Score {{score}}',
  facts: {
    spread: '{{count}} towns',
    reach: '{{count}} themes downstream',
    loops: '{{count}} loops',
    blockers: '{{count}} blockers',
  },
  pairing: 'Pairing: the problem and an answer in different towns',
  members: { show: 'Show members ({{count}})', hide: 'Hide members', source: 'Source: {{source}}' },
  info: {
    tab: 'About',
    title: 'How Common levers works',
    lead: 'This page shows the levers the AI lifted from every project\'s impact map together: the points where acting strengthens the leverage of R&D&I investment in several towns at once.',
    what: { title: 'What a lever is', body: 'A lever is a structure, a way of working or a precondition, not a single solution or project. Behind each one are cards from at least two projects\' maps: its members, which open at the foot of the card.' },
    where: { title: 'Where it comes from', body: 'The AI reads the active cards, blockers and loops of the projects\' impact maps and lifts the common themes. It invents nothing: the title generalises what the members say, and the note tells where the projects agree and where they differ. Every run is a new list; old runs stay.' },
    lens: { title: 'The lens', body: 'A lens is a way of reading the whole material. This page reads the themes together: only levers that join at least two R&D&I themes. Every lever has a level: practices, structures and resources, dynamics and power, or mindsets.' },
    card: { title: 'What the card says', body: 'The kind tells whether this is a shared problem, an outcome or a way of working that worked. Three paragraphs describe the lever in general, give the findings and similarities across projects, and propose how to proceed to a precondition. The score and figures say how many towns, cards, loops and blockers stand behind it.' },
    towns: { title: 'The town pills', body: 'A town pill shows the town\'s role: it has the problem, an answer, or both. Tapping it opens what that town\'s own cards say about this lever and what its team answered. A pairing is one town with the problem and another with an answer.' },
    answers: { title: 'Team answers', body: 'Each team answers on its own page whether the lever is ours, partly ours or not ours, with a short reason. The answers show on the card by town and tell the room what is truly common.' },
    decide: { title: 'The facilitator\'s decision', body: 'The facilitator accepts, dismisses or renames a lever. Accepted levers go on to the next step; dismissed ones stay in the list, marked. A new run replaces the acceptances of the same lens, so decisions are made from the latest list.' },
    next: { title: 'What comes next', body: 'From the accepted levers the room works out the preconditions: what would have to be true for the lever to work, and which routes lead there. The member cards and the town pills show where in the projects\' own experience the routes are.' },
  },
  town: { counts: '{{problem}} problem cards · {{answer}} answer cards in this lever', noMembers: 'This town has no cards in this lever.' },
  edges: { into: 'Comes from', out: 'Leads to' },
  answers: {
    title: 'The teams\' answers',
    none: 'No answers yet.',
    room: '{{yes}} teams say ours · {{partly}} partly',
  },
  answer: { yes: 'ours', no: 'not ours', partly: 'partly' },
  actions: { accept: 'Accept', dismiss: 'Dismiss', restore: 'Restore', hide: 'Hide', show: 'Show', rename: 'Rename', save: 'Save', cancel: 'Cancel' },
  compass: {
    aria: 'Who has the answer: themes inside, towns on the rim',
    legendTitle: 'Who has the answer',
    centre: 'common themes',
    ring: { many: 'in many towns', two: 'in two' },
    zoomIn: 'Zoom in', zoomOut: 'Zoom out', zoomReset: 'Reset',
  },
  team: {
    subtitle: 'Is this ours? One tap per theme; one line why if you like.',
    pick: 'Which team are you?',
    pickHint: 'The choice applies to this device only; answers are saved under the team\'s name.',
    change: 'Change team',
    none: 'No theme touches your team yet.',
    noTeams: 'The workshop has no teams.',
    reasonPlaceholder: 'Why? (optional)',
    saved: 'Saved',
    clear: 'Clear answer',
    yourRole: 'Yours: {{role}}',
  },
};

export const pivotsV3Sv = {
  title: 'Gemensamma hävstångspunkter',
  loading: 'Laddar…',
  loadError: 'Det gick inte att ladda temana: {{message}}',
  saveError: 'Det gick inte att spara: {{message}}',
  noInstance: 'Ingen workshop vald: öppna sidan från workshopens länk (?instance=…).',
  empty: 'Ingen körning ännu. Sök gemensamma teman när teamens kedjor finns på kartan.',
  view: { cards: 'Kort', map: 'Karta', wall: 'Röster' },
  vote: {
    important: 'Viktig',
    hint: 'Viktig för era FoU-mål — ett tryck per team',
    count: '{{count}} team',
    none: 'Inga röster ännu',
    pickTown: 'Välj din stad för att rösta',
    wallTitle: 'Hävstångspunkter efter röster',
    wallHint: 'Varje team markerar på korten dem som är viktiga för dess FoU-mål.',
  },
  demo: {
    title: 'Gemensamma hävstångspunkter — försök med FoU-samarbete',
    lead: 'Gemensamma teman lyfta ur {{teams}} försöksprojekts egen rapportering: vad som återkommer på flera orter, vem som har problemet och vem som redan har ett svar ({{themes}} teman). Byt lins för att se temana genom granskningstemana.',
    pick: 'Välj ett tema i kompassen för att se dess kort.',
    source: 'Ögonblicksbild {{date}}: FoU-workshopens karta, lokalt, anonymiserat material. Endast läsning.',
  },
  run: {
    button: 'Sök gemensamma teman',
    running: 'Söker… (ungefär en minut)',
    failed: 'Sökningen misslyckades: {{message}}',
    latest: 'Körning {{when}} · {{count}} teman',
    none: 'Ingen körning ännu',
    signIn: 'Sökning och beslut kräver att facilitatorn är inloggad.',
  },
  lens: {
    label: 'Lins',
    none: 'Nerifrån och upp (ingen lins)',
    'teema-1': 'Tema 1: företagens tillgång till FoU-systemet',
    'teema-2': 'Tema 2: att samordna kunskap, data och partnerskap',
    'teema-3': 'Tema 3: från forskning till affärsverksamhet',
    'teema-4': 'Tema 4: att bygga nya FoU-ekosystem',
    'teemat-yhdessa': 'Temana tillsammans',
    'uusi-ymmarrys': 'Ny förståelse av FoU-samarbete',
  },
  level: {
    kaytannot: 'praxis',
    rakenteet: 'strukturer och resurser',
    dynamiikka: 'dynamik och makt',
    ajattelumallit: 'tankemodeller',
  },
  kind: { problem: 'problem', outcome: 'resultat', mechanism: 'arbetssätt' },
  role: { problem: 'problem', answer: 'svar', both: 'båda', context: 'bakgrund' },
  status: { proposed: 'förslag', accepted: 'godkänt', dismissed: 'dolt' },
  facilitator: 'Facilitator',
  loop: { reinforcing: 'Förstärkande loop', balancing: 'Balanserande loop', delay: 'med fördröjning', cards: '{{count}} kort' },
  factInfo: {
    spread: 'Städer', reach: 'Teman nedströms och uppströms', loops: 'Loopar genom medlemskorten', blockers: 'Hinder bland medlemmarna', none: 'Inget att visa.',
    spreadLead: 'Städerna vars kort är medlemmar i den här hävstången. Rollen säger om stadens kort beskriver problemet, ett svar eller båda.',
    reachLead: 'Teman nedströms är de som den här hävstången påverkar: orsak–verkan-länkar går från dess medlemskort till deras. Teman uppströms är där verkan kommer ifrån. Vikten är antalet länkar.',
    loopsLead: 'Kartans loopar som går genom den här hävstångens medlemskort: en förstärkande loop förstärker sig själv, en balanserande dämpar.',
    blockersLead: 'Medlemskort som är hinder.',
    down: 'Nedströms', up: 'Uppströms', weight: 'vikt {{count}}',
  },
  drawer: { tab: 'Hävstång', pick: 'Välj en hävstång på kartan så öppnas dess kort här.' },
  generalisation: 'Sammanfattning',
  nextStep: 'Så går vi vidare',
  score: 'Poäng {{score}}',
  facts: {
    spread: '{{count}} orter',
    reach: '{{count}} teman nedströms',
    loops: '{{count}} slingor',
    blockers: '{{count}} hinder',
  },
  pairing: 'Par: problemet och ett svar på olika orter',
  members: { show: 'Visa medlemmar ({{count}})', hide: 'Dölj medlemmar', source: 'Källa: {{source}}' },
  info: {
    tab: 'Om sidan',
    title: 'Så fungerar Gemensamma hävstänger',
    lead: 'Sidan visar de hävstänger som AI:n lyft ur alla projekts effektkartor tillsammans: punkter där en insats stärker FoUI-satsningarnas hävstångseffekt i flera städer på en gång.',
    what: { title: 'Vad en hävstång är', body: 'En hävstång är en struktur, ett arbetssätt eller en förutsättning, inte en enskild lösning eller ett projekt. Bakom varje finns kort från minst två projekts kartor: dess medlemmar, som öppnas längst ner på kortet.' },
    where: { title: 'Var den kommer ifrån', body: 'AI:n läser projektens aktiva kort, hinder och loopar och lyfter de gemensamma temana. Den hittar inte på något: rubriken generaliserar vad medlemmarna säger, och noten berättar var projekten är eniga och var de skiljer sig. Varje körning är en ny lista; gamla körningar finns kvar.' },
    lens: { title: 'Linsen', body: 'En lins är ett sätt att läsa hela materialet. Den här sidan läser temana tillsammans: bara hävstänger som förenar minst två FoUI-teman. Varje hävstång har en nivå: praktiker, strukturer och resurser, dynamik och makt, eller tankemodeller.' },
    card: { title: 'Vad kortet säger', body: 'Slaget anger om det är ett gemensamt problem, ett resultat eller ett arbetssätt som fungerat. Tre stycken beskriver hävstången allmänt, ger iakttagelser och likheter mellan projekten och föreslår hur man går vidare till en förutsättning. Poäng och siffror säger hur många städer, kort, loopar och hinder som står bakom.' },
    towns: { title: 'Stadsmärkena', body: 'Ett stadsmärke visar stadens roll: den har problemet, ett svar eller båda. Ett tryck öppnar vad just den stadens kort säger om hävstången och vad dess team svarat. Ett par uppstår när en stad har problemet och en annan ett svar.' },
    answers: { title: 'Teamens svar', body: 'Varje team svarar på sin egen sida om hävstången är vår, delvis vår eller inte vår, med en kort motivering. Svaren syns på kortet per stad och visar rummet vad som verkligen är gemensamt.' },
    decide: { title: 'Facilitatorns beslut', body: 'Facilitatorn godkänner, avfärdar eller döper om en hävstång. Godkända går vidare till nästa steg; avfärdade stannar i listan, markerade. En ny körning ersätter samma lins godkännanden, så besluten fattas utifrån den senaste listan.' },
    next: { title: 'Vad som kommer sedan', body: 'Ur de godkända hävstängerna arbetar rummet fram förutsättningarna: vad som måste vara sant för att hävstången ska fungera, och vilka vägar som leder dit. Medlemskorten och stadsmärkena visar var i projektens egen erfarenhet vägarna finns.' },
  },
  town: { counts: '{{problem}} problemkort · {{answer}} svarskort i den här hävstången', noMembers: 'Den här staden har inga kort i den här hävstången.' },
  edges: { into: 'Kommer från', out: 'Leder till' },
  answers: {
    title: 'Teamens svar',
    none: 'Inga svar ännu.',
    room: '{{yes}} team säger vårt · {{partly}} delvis',
  },
  answer: { yes: 'vårt', no: 'inte vårt', partly: 'delvis' },
  actions: { accept: 'Godkänn', dismiss: 'Avvisa', restore: 'Återställ', hide: 'Dölj', show: 'Visa', rename: 'Byt namn', save: 'Spara', cancel: 'Avbryt' },
  compass: {
    aria: 'Vem har svaret: teman i mitten, orter på kanten',
    legendTitle: 'Vem har svaret',
    centre: 'gemensamma teman',
    ring: { many: 'på många orter', two: 'på två' },
    zoomIn: 'Zooma in', zoomOut: 'Zooma ut', zoomReset: 'Återställ',
  },
  team: {
    subtitle: 'Är det här vårt? Ett tryck per tema; en rad varför om ni vill.',
    pick: 'Vilket team är ni?',
    pickHint: 'Valet gäller bara den här enheten; svaren sparas i teamets namn.',
    change: 'Byt team',
    none: 'Inget tema berör ert team ännu.',
    noTeams: 'Workshopen har inga team.',
    reasonPlaceholder: 'Varför? (valfritt)',
    saved: 'Sparat',
    clear: 'Ta bort svaret',
    yourRole: 'Hos er: {{role}}',
  },
};
